(function() {
    'use strict';
    var trackingUtils = require('../modules/utils/tracking.utils');
    var tagManagement = require('../modules/utils/tag_management.utils');
    const registerFactory = require('components/user_area/register_manager/js/main');
    const createWidgetLoader = require('components-framework/widget/create_widget_loader');


    Odigeo.Router.handlers.register = function() {
        var page = 'register';
        const widgetLoader = createWidgetLoader({
            register: ['register-manager', registerFactory],
        });

        $('#page').removeClass().addClass(page);

        Odigeo.Session.set('page', 'register');

        Odigeo.Router.eventController = $.extend(true,
            Odigeo.Router.eventController,
            Odigeo.Router.handlers.globalEventController,
            Odigeo.Router.handlers.userEventController,
            {
                // Global events will remain bound in any part of the application
                globalEvents: {
                    'global:userLogged': 'onUserLogged',
                },
                // View or local events which are triggered from this view.
                // They will be unbinded when the view changes.
                viewEvents: {
                    /** Users Manager */
                    'users-manager:registerOk': 'onRegisterEvent',
                    'users-manager:registerWithError': 'onRegisterEvent',
                    'users-manager:registerError': 'onRegisterEvent',
                    /** Register with Facebook */
                    'users-manager:registerWithFacebookOk': 'onRegisterEvent',
                    'users-manager:registerWithFacebookWithError': 'onRegisterEvent',
                    'users-manager:registerWithFacebookError': 'onRegisterEvent',
                    /** Register with Google */
                    'users-manager:registerWithGoogleOk': 'onRegisterEvent',
                    'users-manager:registerWithGoogleWithError': 'onRegisterEvent',
                    'users-manager:registerWithGoogleError': 'onRegisterEvent',

                    /** update user information with the social login profile info */
                    'users-manager:updateAccountInfoOk': 'onRegisterEvent',
                    'users-manager:updateAccountInfoWithError': 'onRegisterEvent',
                    'users-manager:updateAccountInfoError': 'onRegisterEvent',

                    /** Register */
                    'register-manager:submitUserRequest': 'onSubmitUserRequest',
                    'register-manager:registerSuccess': 'onChangeHeader',

                    /** Recaptcha */
                    'recaptcha:loaded': 'onRecaptchaLoaded',

                },
                // implementation of events handlers
                eventHandlers: {
                    onRegisterEvent: function(data) {
                        widgetLoader.get('register').execute(data.action, data);
                    },

                    onChangeHeader: function() {
                        $('.header_funnel_background').addClass('od-header-register-short');
                    },

                    onSubmitUserRequest: function(data) {
                        Odigeo.requireWidget('users-manager', 'usersmanager', function(usersmanager) {
                            usersmanager.execute('submitUserRequest', data);
                        });
                    },

                    onUserLogged: function() {
                        Odigeo.Utils.goToApplicationHome();
                    },

                    onRecaptchaLoaded: function() {
                        widgetLoader.get('register').execute('renderCaptcha');
                    },
                },
            });
        Odigeo.Router.eventController.execute();
        widgetLoader.get('register');

        Odigeo.Utils.sessionTimer.reset();

        // Analytics: virtual page tracking
        trackingUtils.trackPage('register', {
            funnel: false,
        });
        tagManagement.updateDatalayer();
    };
}());
